<template>
  <div class="terms">
    <b-container>
      <b-row class>
        <b-col md="12" sm="12">
          <p class="text text-justify paragraphs" v-for="(para,index) in paragraphs" :key="index">{{para}}</p>
        </b-col>
        <Titlepara v-for="(par,index) in paras" :key="index" :para="par" />
        
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Titlepara from "../common/title-para";
export default {
  name: "Terms",
  props: ["paragraphs", "paras"],
  components: {
    Titlepara,
  },
};
</script>
<style scoped>
.card1 {
  border-radius: 20px;
}
.title {
  color: #2a4b7c;
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 2rem;
  text-align: center;
  text-decoration: underline;
}
.heading {
  color: #2a4b7c;
  background: transparent;
  border: none;
  margin-bottom: 1.25rem;
  margin-top: 1.25rem;
}
.sub-heading {
  color: #2a4b7c;
  background: transparent;
  border: none;
  text-indent: 1.25rem;
}
.text {
  color: #2a4b7c;
  font-size: 16px;
  font-weight: 500;
  /* text-indent: 1.25rem; */
}
li::marker {
  color: #e7242a;
  font-weight: 600;
}

@media (max-width: 767px) {
  .text {
    font-size: 0.75rem;
  }
}
</style>